import { showSteps } from "actions/ui_control";
import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";

function TryDemoSection() {
  const dispatch = useDispatch();
  const showStepsFunc = () => {
    dispatch(showSteps());
  };
  return (
    <section id="try-demo-section">
      <Container>
        <Row
          className="justify-content-center align-items-center p-5"
          style={{ minHeight: "400px" }}
        >
          <Col className="text-center">
            <h2 className="mb-4">Let's do a Demo?</h2>
            <p className="large-p mb-4">
              See how our instruction form makes everything easy.
            </p>
            <button
              style={{ width: "153px", height: "48px" }}
              className="btn button-purple-gradient mb-2 me-2"
              onClick={showStepsFunc}
            >
              Try Demo
            </button>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default TryDemoSection;
